import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import { PlusMembershipInfoProps } from 'components/Plus/PlusMembershipInfo/PlusMembershipInfo';
import usePlusMembershipStatus from 'components/Plus/hooks/usePlusMembershipStatus';
import styles from './PlusMembershipInfo.module.scss';

const PlusMembershipInfoCta: FC<PlusMembershipInfoProps> = ({
  onRepurchaseMembership,
  onCancelMembership,
  onContactCustomerSupport,
}) => {
  const {
    isCancelled,
    isCancelledBeforeRenewal,
    isMembershipWithdrawn,
    legacyExpiringSoon,
    isFailedPaymentPaused,
    isFailedPaymentCancelled,
    isLegacyOpPlus,
    isActiveLessThan14Days,
  } = usePlusMembershipStatus();

  const { t } = useTranslation();

  if (
    isCancelled ||
    isCancelledBeforeRenewal ||
    isFailedPaymentPaused ||
    isFailedPaymentCancelled ||
    isMembershipWithdrawn
  ) {
    return (
      <div className={styles.membershipInfoButton}>
        <OpButton onClick={onRepurchaseMembership} block variant="primary" color="teal">
          <OpText variant="body-large-medium" className={styles.ctaText}>
            {t('txt_plus_membership_repurchase')}
          </OpText>
        </OpButton>
      </div>
    );
  }

  if (legacyExpiringSoon) {
    return (
      <div className={styles.membershipInfoButton}>
        <OpButton onClick={onRepurchaseMembership} block variant="primary" color="teal">
          <OpText variant="body-large-medium" className={styles.ctaText}>
            {t('txt_sign_up')}
          </OpText>
        </OpButton>
      </div>
    );
  }

  if ((isLegacyOpPlus && !legacyExpiringSoon) || isActiveLessThan14Days) {
    return (
      <div className={styles.membershipInfoButton}>
        <OpButton onClick={onContactCustomerSupport} block variant="primary" color="teal">
          <OpText variant="body-large-medium" className={styles.ctaText}>
            {t('txt_plus_contact_customer_support')}
          </OpText>
        </OpButton>
      </div>
    );
  }

  return (
    <div className={styles.membershipInfoButton}>
      <OpButton onClick={onCancelMembership} block variant="secondary" color="action">
        <OpText variant="body-large-medium" className={styles.ctaText}>
          {t('txt_end_membership')}
        </OpText>
      </OpButton>
    </div>
  );
};

export default PlusMembershipInfoCta;
